module.exports = __webpack_public_path__ + "static/media/ampulheta_circulo.f2d9da76.png";